import React, { useState } from 'react';
import './TextArea.css';

const TextArea = ({
  labelName,
  id,
  onChangeFunction,
  value,
  icon,
  required,
}) => {
  const [replicatedValue, setReplicatedValue] = useState('');

  const handleInput = (e) => {
    setReplicatedValue(e.target.value);
  };

  return (
    <div
      className="form-floating grow-wrap"
      data-replicated-value={replicatedValue}
    >
      <textarea
        className="form-control text-area"
        rows={1}
        cols={50}
        id={id}
        placeholder={labelName}
        value={value}
        onChange={onChangeFunction}
        onInput={handleInput}
        required={required}
      />
      <label htmlFor={id} className="form-label">
        {icon && <img src={icon} height={18} width={18} alt="input icon" />}
        {labelName}
      </label>
    </div>
  );
};

export default TextArea;
